import { type ReactElement, useState } from 'react'

import { resolveInstallShellCopy } from './install-shell-copy.js'
import { useInstallPrompt } from './use-install-prompt.js'

/**
 * The install-page shell. Deliberately dependency-light and self-contained: this bundle is
 * precached by the service worker and must keep booting when the install origin is blocked, so it
 * avoids heavyweight runtime styling/i18n libraries. Its copy is localised through the featherweight
 * {@link resolveInstallShellCopy} (en/vi) rather than the lingui runtime, keeping the install-critical
 * bundle small. Shown while boot-time API discovery is still running and when it finds no trusted
 * domain — in both cases guiding the user to install (and so benefit from the precached shell) is
 * the useful thing to do.
 */
export const InstallShell = (): ReactElement => {
  const { promptInstall, status } = useInstallPrompt()
  // Resolve copy once at mount — the locale cannot change without a fresh launch, same as the
  // standalone check the nudge snapshots.
  const [copy] = useState(resolveInstallShellCopy)

  return (
    <main className="shell">
      <h1 className="shell__title">TauroMarkets</h1>
      <p className="shell__lead">{copy.lead}</p>

      {status === 'available' && (
        <button className="shell__cta" type="button" onClick={() => void promptInstall()}>
          {copy.install}
        </button>
      )}

      {status === 'installed' && <p className="shell__note">{copy.installed}</p>}

      {(status === 'dismissed' || status === 'unavailable') && (
        <p className="shell__note">
          {copy.iosHintBefore}
          <strong>{copy.iosHintAction}</strong>
          {copy.iosHintAfter}
        </p>
      )}
    </main>
  )
}
